import { getClientApplicationConfig } from '@hc-frontend/core-context';
import type { DncResponse } from '@hc-frontend/services';

export function UnsubscribeResult({
  dncResponse,
}: {
  dncResponse: DncResponse;
}) {
  let messages: string[] = [];
  const { boberdoo } = dncResponse;
  const { maropost } = dncResponse;
  const { drips } = dncResponse;
  const config = getClientApplicationConfig();

  const success =
    (boberdoo != null ? boberdoo.success : true) &&
    (maropost != null ? maropost.success : true) &&
    (drips != null ? drips.success : true);

  const dripsMessage = drips ? drips.message : '';

  if (dncResponse.has_data) {
    if (success) {
      messages = [
        boberdoo ? boberdoo.message : dripsMessage,
        maropost ? maropost.message : '',
        'Please note that you may continue to receive some communications while our systems update according to your request.',
        'If you continue to recieve notifications after 24 hours, please contact cris@healthcare.com with subject: "DNC Request Error".',
      ];
    } else {
      messages = [
        'Your contact information has been added to our do not contact list.',
        'Please note that you may continue to receive some communications while our systems update according to your request.',
        'If you believe you\'ve received this message in error, please contact cris@healthcare.com with subject: "DNC Request Error".',
      ];
    }
  } else {
    messages = [
      'We are unable to find your email/phone number in our system.',
      'If you believe this is a mistake, please contact cris@healthcare.com with subject: "DNC Request Error".',
    ];
  }

  return (
    <>
      <img
        aria-label="unsubscribe-check"
        src={`${config.assets.marketplaceStaticBaseUrl}/marketplace/images/unsubscribe-check.png`}
        alt="Success!"
        width={120}
        height={100}
      />
      {messages.map((error) => (
        <p className="hc-typography--heading-four text-center" key={error}>
          {error}
        </p>
      ))}
    </>
  );
}
